import { BondOrderStatus } from 'global/Securities/types/api/bond';
import { StepperLinkedList, StepperStatus, StepperStep } from './types';

export const StatusIndicatorMap: Record<StepperStatus, string> = {
  UNSPECIFIED: 'icon/fr/icon-stepper-unspecified.svg',
  REJECTED: 'icon/fr/icon-stepper-rejected.svg',
  SUCCESS: 'icon/fr/icon-stepper-success.svg',
  ON_PROGRESS: 'icon/fr/icon-stepper-on_progress.svg',
};

export const BondOrderStatusMap: Record<BondOrderStatus, StepperStatus> = {
  BOND_ORDER_STATUS_UNSPECIFIED: 'UNSPECIFIED',
  BOND_ORDER_STATUS_REJECTED: 'REJECTED',
  BOND_ORDER_STATUS_SUBMITTED: 'ON_PROGRESS',
  BOND_ORDER_STATUS_SUCCEEDED: 'SUCCESS',
  BOND_ORDER_STATUS_VERIFIED: 'SUCCESS',
};

export const BondOrderStatusLabelMap: Record<BondOrderStatus, string> = {
  BOND_ORDER_STATUS_UNSPECIFIED: 'Unspecified',
  BOND_ORDER_STATUS_REJECTED: 'Rejected',
  BOND_ORDER_STATUS_SUBMITTED: 'Submitted',
  BOND_ORDER_STATUS_SUCCEEDED: 'Success',
  BOND_ORDER_STATUS_VERIFIED: 'Verified',
};

export const BondOrderStatusStepMap: Record<BondOrderStatus, StepperStep> = {
  BOND_ORDER_STATUS_UNSPECIFIED: StepperStep.REJECTED,
  BOND_ORDER_STATUS_REJECTED: StepperStep.REJECTED,
  BOND_ORDER_STATUS_SUBMITTED: StepperStep.SUBMITTED,
  BOND_ORDER_STATUS_SUCCEEDED: StepperStep.SUCCESS,
  BOND_ORDER_STATUS_VERIFIED: StepperStep.SUBMITTED,
};

export const stepperContentList: StepperLinkedList[] = [
  {
    prev: undefined,
    next: StepperStep.VERIFIED,
    current: StepperStep.SUBMITTED,
    content: {
      date: undefined,
      status: 'UNSPECIFIED',
      descriptions: undefined,
      label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUBMITTED,
    },
  },
  {
    prev: StepperStep.SUBMITTED,
    next: StepperStep.SUCCESS,
    current: StepperStep.VERIFIED,
    content: {
      date: undefined,
      status: 'UNSPECIFIED',
      descriptions: undefined,
      label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_VERIFIED,
    },
  },
  {
    prev: StepperStep.VERIFIED,
    next: undefined,
    current: StepperStep.SUCCESS,
    content: {
      date: undefined,
      status: 'UNSPECIFIED',
      descriptions: undefined,
      label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUCCEEDED,
    },
  },
];
